import { render, staticRenderFns } from "./CreateKekurangan.vue?vue&type=template&id=e25c522e"
import script from "./CreateKekurangan.vue?vue&type=script&lang=js"
export * from "./CreateKekurangan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports